import TooltipHover from "@/components/ui/TooltipHover";
import { cn } from "@/lib/utils";
import { BookMarked } from "lucide-react";

type Props = {
  isOpen: boolean;
  setIsOpen: (arg: boolean) => void;
};

const AppFilesButton = ({ isOpen, setIsOpen }: Props) => {
  const iconSize = "h-6 w-6";
  const iconWeight = 1.6;

  return (
    <div
      className={cn(
        "absolute right-2.5 bottom-2.5 h-fit w-fit p-3 border border-brand-gray-300 hover:border-brand-primary bg-gradient-to-bl from-brand-primary/15 to-brand-primary/5 rounded-md z-10 flex cursor-pointer group transition-all",
        isOpen && "xxxl:hidden"
      )}
      role="button"
      tabIndex={-1}
      aria-label="Show app user guide and release notes"
      onClick={() => setIsOpen(true)}
    >
      <TooltipHover
        text="Show app user guide and release notes"
        placement="left"
      >
        <BookMarked
          strokeWidth={iconWeight}
          className={cn(
            "fill-white text-brand-gray-400 group-hover:text-brand-primary",
            iconSize
          )}
        />
      </TooltipHover>
    </div>
  );
};

export default AppFilesButton;
